<script>
    import DesktopButton from '../../reusableitems/DesktopButton.svelte';
    let heading;
setTimeout(()=> {
        heading.style.fontSize='3.704vh';
        heading.style.width= '81.759vh';
}, 9100);
</script>

<div class="main-div">
    <div class="image">
        <img src="/images/createMainDesktop/unsplash.png" width="100%" height="100%"
        alt="">
    </div>
    
    <div>
        <p class="heading1">UNLEASH</p>
    </div>
    
    <div class="heading2">
        <p >YOUR</p>
    </div>
    
    <div class="heading3">
        <p >IMAGINATION</p>
    </div>
    <div class="heading4" bind:this={heading}>
        <p >
            & let our <b> TECHNOLOGY </b> do the work.
        </p>
    </div>
    <div class="bottomText">
        <p>
            We’re building the future where storytellers no longer are a passive
            wordslinger, rather an active orchestrator interacting with a live
            3D canvas which turns your words into a living breathing world in
            the blink of an eye.
            <br /><br />
            Write scenes, characters and their dialogs and watch it happen in real
            time.
        </p>
        <div style="margin-top:2vw;">
            <DesktopButton
            width='max(28.611vh , 154.5px)'
            state = "StoryTeller"
                text="Join Storytellers Governance Council"
                TextColor2="white"
                AnimationColor="#F4DCFF"
                TextColor="#F4DCFF"
                borderClr="0.1vw solid #F4DCFF"
                BorderClrAfter="0.1vw #F4DCFF"
                BackColor="transparent"
                TextColorAFter="black"
            />
        </div>
        <div class="scroll">
            <div>
                <p>Scroll / Drag</p>
            </div>
            <div class="imageWrraper">
                <img
                    src="/images/create-section/Line14.png"
                    alt="arrow"
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
    </div>
</div>

<style>
    p {
        margin: 0;
        font-family: "Orbitron";
    }
    .main-div {
        position: relative;
        height: 100vh;
        width: 100vw;  
    }
    .image{
        height: 100vh;
        width: 100vw;  
    }
    .image::after{
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0)(255, 255, 255);
    }
    .heading1 {
        position: absolute;
        left: 11.759vh;
        top: 21.296vh;
        font-weight: 900;
        font-size: 5.556vh;
        color: #ffffff;
    }
    .heading2 {
        position: absolute;
        left: 27.13vh;
        top:27.130vh;
        font-weight: 900;
        font-size: 5.556vh;
        color: #ffffff;
    }
    .heading3 {
        position: absolute;
        left: 11.759vh;
        top: 33.481vh;
        font-weight: 900;
        font-size: 13.889vh;
        line-height: 13.889vh;
        color: #f4dcff;
        letter-spacing: 0.1vw;
    }
    .heading4 {
        position: absolute;
    left: 42.833vh;
    top: 47.833vh;
    font-weight: 400;
    font-size: 2vh;
    line-height:  3.704vh;
    color: #ffffff;
    float: right;
    width: 81.759vh ;
    transition-duration: 1s;
    }
    .bottomText {
        width: 59.531vw;
        height: 19.896vw;
        background: #000000;
        opacity: 0.8;
        border-radius: 5.208vw 0vw 0vw 0vw;
        position: absolute;
        bottom: 0;
        right: 0;
        box-sizing: border-box;
        padding: 3vw;
    }
    .bottomText p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 500;
        font-size: 1.042vw;
        line-height: 140%;
        letter-spacing: 0.06em;
        color: #ffffff;
    }
    .scroll {
        color: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        float: right;
        width: 12vw;
    }
    .scroll p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 0.938vw;
    }
    .scroll .imageWrraper {
        width: 3.698vw ;
        height: fit-content;
    }
</style>
